import {
  __CLASS_CSR_CMP__
} from "@/const/ssrClass.js";

export const getCsrCmpItemState = (el) => {
  const { id, dataset } = el;
  const { cmp } = dataset;
  let { conf } = dataset;
  // 优先取dom dataset中的data-conf配置
  if (conf) {
    conf = JSON.parse(conf)
  }
  // 若不存在则取window.__AEM_CONF__.components中的配置
  else {
    conf = window?.__AEM_CONF__?.components?.[id] || {}
  }
  conf = Object.assign(conf, {
    error: false,
  });
  const { defaultValue = null } = conf;
  return {
    value: defaultValue,
    id,
    cmp,
    el,
    conf
  }
}
// 所有csr组件的状态统一平铺在csrState中
export const createState = () => {
    const crsComponents = document.querySelectorAll(
      `.${__CLASS_CSR_CMP__}`
    );
    const csrState = {};
    crsComponents.forEach(el => {
      csrState[el.id] = getCsrCmpItemState(el);
    });

    return {
      csrState,
      // 记录表单字段被改变，需要监听的字段使用watch进行监听
      formFieldChange: {
        value: null,
        id: null
      },
      // model-number选中的suggestion对象（含buId/subCategory等完整字段），供category/sub-category联动使用
      selectedModel: null,
    };
}